// Versão nova do app instalado. O service worker novo espera (sw.ts não pula a espera sozinho) e o app oferece
// "Atualizar": tocar manda "skip-waiting" e, quando o novo assume (controllerchange), a página recarrega. A fila de
// saída mora no IndexedDB e sobrevive ao recarregar; quem chama decide se dá para recarregar agora (nota em edição).
type Waiting = { state: string; postMessage(m: unknown): void; addEventListener(t: "statechange", f: () => void): void };
export type Registration = { waiting: Waiting | null; installing: Waiting | null; addEventListener(t: "updatefound", f: () => void): void };
export type Container = { controller: unknown; addEventListener(t: "controllerchange", f: () => void): void };
export type UpdateUi = { offer(apply: () => void): void; reload(): void };

/** Liga os avisos de versão nova. Devolve `check`, para chamar depois de cada registration.update(). */
export function watchUpdates(reg: Registration, sw: Container, ui: UpdateUi): () => void {
  let asked = false;
  // Primeira instalação: o SW assume a página (clients.claim) sem ser "versão nova"; essa troca não pede nada.
  let controlled = !!sw.controller;
  const apply = () => {
    asked = true;
    reg.waiting?.postMessage("skip-waiting");
  };
  const check = () => void (reg.waiting && sw.controller && ui.offer(apply));
  reg.addEventListener("updatefound", () => {
    const w = reg.installing;
    w?.addEventListener("statechange", () => w.state === "installed" && check());
  });
  sw.addEventListener("controllerchange", () => {
    // Sem controlador: o SW foi apagado (Clear-Site-Data ao sair ou encerrar a conta), não há versão nova.
    if (!sw.controller) return;
    if (!controlled) return void (controlled = true);
    // Outra aba aceitou a versão: esta segue com o código antigo até a pessoa recarregar.
    if (asked) ui.reload();
    else ui.offer(ui.reload);
  });
  check();
  return check;
}
